import { partnerConfig } from './partners'

export const partnerArray = Object.keys(partnerConfig).reduce((sum, item) => {
  sum.push({id: item, ...partnerConfig[item]})
  return sum
}, [])

export const companyArray = partnerArray.map(item => ({
  value: item.id,
  label: item.name,
  py: item.py,
  jp: item.jp,
  sortNum: item.sortNum
}))

export default {
  companyArray
}



// WEBPACK FOOTER //
// ./src/data/company.js